import { GridList, type GridListAction } from '@/components/ui/grid-list';
import { Wrench, Settings, BadgeCheck, FolderDown } from 'lucide-react';

const actions: GridListAction[] = [
  {
    title: 'Auto Test',
    href: '/production/logs/auto-test',
    icon: Wrench,
    iconForeground: 'text-blue-700',
    iconBackground: 'bg-blue-50',
    description: 'Acessar e verificar o resultado do processo de auto teste',
  },
  {
    title: 'Configurador',
    href: '/production/logs/configurator',
    icon: Settings,
    iconForeground: 'text-amber-700',
    iconBackground: 'bg-amber-50',
    description: 'Acessar e verificar o resultado do processo de configuração',
  },
  {
    title: 'Identificador',
    href: '/production/logs/identificator',
    icon: BadgeCheck,
    iconForeground: 'text-cyan-700',
    iconBackground: 'bg-cyan-50',
    description: 'Acessar e verificar o resultado do processo de identificação do equipamento.',
  },
  {
    title: 'Gravador de Firmware',
    href: '/production/logs/firmware-update',
    icon: FolderDown,
    iconForeground: 'text-orange-700',
    iconBackground: 'bg-orange-50',
    description: 'Acessar e verificar o resultado do processo de gravação de firmware.',
  },
];

export function ProductionLogsPage() {
  return (
    <div>
      <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
        <div>
          <h1 className="text-base font-semibold leading-7 text-gray-900">
            Módulo Produção - Logs
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            Esse módulo é responsável por apresentar os logs gerados pelas
            ferramentas utilizadas pela Produção.
          </p>
        </div>
      </div>
      <div className="mt-10 flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
        <GridList actions={actions} className="bg-unset" />
      </div>
    </div>
  );
}
